import React from "react";

// Placeholder for report pages that aren't built yet.
export default function ComingSoonPage({ title }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl px-6 py-16 text-center">
      <p className="font-semibold text-slate-700">{title} is coming soon</p>
      <p className="text-sm text-slate-400 mt-1">Its numbers are already on Market Snapshot.</p>
    </div>
  );
}
